<template>
	<div class="cd-item-status">
		<div v-if="item.product_condition && item.product_condition != 'n'" class="cd-condition-badge-container">
			<div class="cd-condition-badge" @click="flyoutCondition(labels.get('flyout_title_condition_' + item.product_condition),labels.get('flyout_content_condition_' + item.product_condition))">
				<span v-html="labels.get('condition_' + item.product_condition)"></span>
			</div>
		</div>

		<template v-if="item.status">
			<div v-if="item.status == 1" class="cd-available-qty" :class="{'special': shippingOption('p')}">
				<span v-if="(item.last_piece_sale != 0 && item.last_piece_sale) && item.warehouses_single_pickup_display" class="available-last" v-html="labels.get('odprodaja')"></span>
				<span v-else-if="item.last_piece_sale != 0 && item.last_piece_sale" v-html="labels.get('odprodaja_2')" class="available-last"></span>
				<span v-else v-html="labels.get('na_zalogi')"></span>
			</div>
			<div v-else-if="item.status == 2" class="cd-available-qty">
				<span>{{ labels.get('na_zalogi_dobavitelja').replace('%MIN_DAY%', item.availability_info.min_days).replace('%MAX_DAY%', item.availability_info.max_days) }}</span>
			</div>
			<div v-else-if="item.status == 4" class="cd-available-qty" :class="{'special': shippingOption('p')}">
				<span class="available-last" v-html="labels.get('na_zalogi_ena')"></span>
			</div>
			<div v-else-if="item.status == 5" class="cd-available-qty">
				<template v-if="item.is_available">
					<span v-if="item.date_available">{{ labels.get('na_voljo') }} {{ item.date_available.includes('.') ? item.date_available : formatDate(item.date_available) }}</span>
				</template>
				<span v-else class="unavailable" v-html="labels.get('ni_na_zalogi_preorder')"></span>
			</div>
			<div v-else-if="item.status == 7" class="cd-available-qty">
				<span class="unavailable" v-html="labels.get('ni_na_zalogi')"></span>
			</div>
			<div v-else-if="item.status == 9" class="cd-available-qty">
				<span class="unavailable" v-html="labels.get('dalj_ni_na_zalogi')"></span>
			</div>
		</template>

		<div v-if="shippingOption('p') && (item.status == 1 || item.status == '4')" @click="flyoutStores()" class="cd-item-status-stores">
			<span class="title" :class="{'special': warehousesQty > 0}">{{ labels.get('warehouses_availability_status') }}</span>
			<span v-if="warehousesQty > 0" class="count"> ({{ warehousesQty }})</span>
			<span class="arrow"></span>
		</div>
	</div>
</template>

<script setup>
	const labels = useLabels();
	const {formatDate} = useText();
	const {emit} = useEventBus();
	const item = useState('product');

	function shippingOption(id) {
		return item.value?.shipping_options?.some(item => item.id === id);
	}

	const warehousesQty = computed(() => {
		return item.value?.warehouses?.filter(warehouse => warehouse.available_qty > 0).length;
	});

	function flyoutStores() {
		document.body.classList.add('flyout-page', 'cd-flyout-active');

		let title = labels.get('item_stores_flyout_title');
		if(item.value?.status == 4 && item.value?.warehouses_display) {
			title = labels.get('item_stores_flyout_title')
		}

		const content = {
			status: item.value?.status,
			warehouses_single_pickup_display: item.value?.warehouses_single_pickup_display,
			last_piece_sale: item.value?.last_piece_sale,
			warehouses_display: item.value?.warehouses_display,
			is_available: item.value?.is_available,
			shipping_options: item.value?.shipping_options
		};

		emit('flyoutUpdate', {'flyout_mode': 'stores', 'flyout_title': title, 'flyout_content': content ? content : null});
	}

	function flyoutCondition(title, content) {
		document.body.classList.add('flyout-page', 'cd-flyout-active');

		emit('flyoutUpdate', {'flyout_mode': 'condition', 'flyout_title': title, 'flyout_content': content ? content : null});
	}
</script>

<style lang="less" scoped>
	.cd-condition-badge-container{width: 100%; margin-bottom: 10px;}
	.cd-condition-badge{
		display: inline-flex; align-items: center; justify-content: center; min-height: 29px; padding: 2px 14px; background: #CDD700; border-radius: 15px; font-size: 14px; cursor: pointer;
		span{
			display: flex; align-items: center; padding: 0 14px 0 0; position: relative; font-weight: bold;
			&:before{content: none;}
			&:after{.icon-arrow-down(); font: 8px/1 @fonti; font-weight: 600; color: #002D73; position: absolute; right: 0; padding-top: 1px; .rotate(-90deg); .transition(all);}
		}
		@media (min-width: @t){
			&:hover span:after{right: -3px;}
		}

		@media (max-width: @m){
			order: 2;
			span:after{padding-top: 2px;}
		}
	}
	.cd-item-status {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		width: 100%;
		margin: 0 0 15px;
		position: relative;

		@media (max-width: @m) {
			width: calc(~'100% - -30px');
			margin: 0 0 -1px -15px;
			padding: 13px 15px;
			border-top: 1px solid @borderColor;
			border-bottom: 1px solid @borderColor;
		}
	}
	.cd-available-qty {
		display: flex;
		align-items: center;
		font-size: 15px;
		line-height: 1.4;
		color: @lightGreen;
		font-weight: 600;
		padding: 5px 0;
		&.special {
			padding-right: 11px;
			margin-right: 10px;
			position: relative;
			&:before {
				.pseudo(1px,14px);
				background: @borderColor;
				right: 0;
			}
		}
		span {
			padding: 0 0 0 25px;
			position: relative;
			&:before {
				.icon-available();
				font: 17px/17px @fonti;
				color: @lightGreen;
				position: absolute;
				top: 2px;
				left: 0;
			}
		}
		.available-last {
			color: @gray;
			text-decoration-color: @textColor;
			&:before {
				.icon-available-last();
				font-size: 14px;
				line-height: 14px;
				color: @orange;
				top: 3px;
			}
		}
		.unavailable {
			color: @gray;
			padding: 0;
			text-decoration: none;
			&:before {
				content: none;
			}
		}

		@media (max-width: @m) {
			padding: 0 10px 0 0;
			flex-grow: 1;
			order: 1;
			&.special {
				padding: 0;
				margin: 0 0 8px;
				&:before {
					content: none;
				}
			}
			span:before {
				top: 3px;
			}
			.available-last:before {
				top: 4px;
			}
		}
	}
	.cd-item-status-stores {
		display: inline-block;
		padding: 5px 0;
		font-size: 15px;
		line-height: 1.4;
		font-weight: 600;
		color: @blue;
		white-space: nowrap;
		cursor: pointer;
		position: relative;
		.title {
			padding-left: 25px;
			position: relative;
			&:before {
				.icon-store2();
				font: 16px/1 @fonti;
				color: @textColor;
				position: absolute;
				top: 2px;
				left: 0;
			}
			&.special:after {
				.pseudo(5px,5px);
				background: #0091a0;
				border: 3px solid @white;
				border-radius: 100%;
				left: 10px;
				top: 10px;
				z-index: 1;
			}
		}
		.count {
			color: @blue;
		}
		.arrow {
			display: inline-flex;
			padding-left: 7px;
			position: relative;
			.transition(transform);
			&:after {
				.icon-arrow-down();
				font: 8px/1 @fonti;
				font-weight: 600;
				color: @blue;
				position: relative;
				top: -2px;
				.rotate(-90deg);
			}
		}
		span {
			font-weight: 600;
		}
		@media (min-width: @t) {
			&:hover .arrow {
				transform: translateX(5px);
			}
		}

		@media (max-width: @m) {
			display: block;
			padding: 0;
			width: 100%;
			order: 3;
		}
	}
</style>
